import { useState, useEffect } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import axios, { baseURL } from "utils/api";

const columns2 = [
  { name: "sno", align: "center" },
  { name: "Address", align: "left" },
  { name: "lat", align: "center" },
  { name: "lng", align: "center" },
  { name: "radius", align: "center" },
  // { name: "action", align: "center" },
];

const LocationPreferenceTableData = (id, refresh) => {
  const [rows2, setRows] = useState([]);

  useEffect(() => {
    if (!id) return;
    axios
      .get(`${baseURL}/tutor?id=${id}`)
      .then((res) => {
        console.log("Tutor Details API Response:", res.data);
        const tutor = res.data.data;
        const locations = tutor.locationPreference || [];
        console.log("Locations:", locations);

        const formattedRows = locations.map((loc, index) => {
          // Use the tutor's address for the location preference
          const fullAddress = tutor.address || "N/A";

          return {
            sno: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {index + 1}
              </ArgonTypography>
            ),
            Address: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {fullAddress}
              </ArgonTypography>
            ),
            lat: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {loc.lat ? loc.lat.toFixed(4) : "N/A"}
              </ArgonTypography>
            ),
            lng: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {loc.lng ? loc.lng.toFixed(4) : "N/A"}
              </ArgonTypography>
            ),
            radius: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                {loc.radius || "N/A"}
              </ArgonTypography>
            ),
          };
        });

        setRows(formattedRows);
      })
      .catch((err) => {
        console.error("❌ Error fetching tutor teaching preferences:", err);
      });
  }, [id, refresh]);

  return { columns2, rows2 };
};

export default LocationPreferenceTableData;
